import { useCertificates } from '../../hooks/useCertificates'

import BtnSquare from '../../components/Buttons/BtnSquare'
import styled from 'styled-components'
import { UserCertificatesDTO } from '../../infrastructure/api-signup'
import DayJS from '../../helpers/DayJS'
import { Icon } from '../../components/Icon'

const CertificateItem = (certificate: UserCertificatesDTO) => {
    const { shareToLinkedIn, isSharingToLinkedIn, downloadPDFCertificate, isDownloading } = useCertificates()

    const { title, issueDate } = certificate
    const date = DayJS(issueDate).format('LL')

    return (
        <CertificateItemStyled>
            <div className="icon">
                <Icon icon={['fal', 'file-certificate']} />
            </div>
            <div className="certificate">{title}</div>
            <div className="date">{date}</div>
            <div className="share">
                <BtnSquare onClick={() => shareToLinkedIn(certificate)} mode="light">
                    {isSharingToLinkedIn ? <Icon icon={['fal', 'spinner']} spin /> : <Icon icon={['fab', 'linkedin']} />}
                </BtnSquare>
                <BtnSquare disabled={isDownloading} onClick={() => downloadPDFCertificate(certificate)} mode="light">
                    {isDownloading ? <Icon icon={['fal', 'spinner']} spin /> : <Icon icon={['fal', 'circle-arrow-down']} />}
                </BtnSquare>
            </div>
        </CertificateItemStyled>
    )
}

export default CertificateItem

const CertificateItemStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px 0;
    padding-bottom: 20px;
    &:not(:last-child) {
        border-bottom: ${props => `1px solid ${props.theme.color.lightGray}`};
    }
    .icon {
        font-size: 24px;
        flex: 0.1;
        text-align: center;
    }
    .course {
    }
    .certificate {
        flex: 1;
        font-size: 15px;
        padding: 0 10px;
        text-transform: capitalize;
    }
    .date {
        font-size: 15px;
        padding: 0 10px;
    }
    .share {
        display: flex;
    }
`
